import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast"; 
import TabelaHeader from "./TabelaHeader";
import TabelaRow from "./TabelaRow";
import Paginacao from "./Paginacao";
import Detalhe from "../detalhes/Detalhe";
import ConfirmarExclusaoModal from "../detalhes/ConfirmarExclusaoModal"; 
import FormularioEditarChamado from "../editar/FormularioEditarChamado";

const API_URL = process.env.REACT_APP_API_URL;

export default function TabelaChamados({ onStatusCountsChange, filtroStatus }) {
  const [chamados, setChamados] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filtro, setFiltro] = useState({
    data: "",
    hora: "",
    empresa: "",
    colaborador: "",
    tipo_servico: "",
    tecnico_responsavel: "", // ✅ corrigido
    status: "",
  });

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(10);

  // 🔹 Estado para detalhe
  const [chamadoSelecionado, setChamadoSelecionado] = useState(null);

  // 🔹 Estado para excluir
  const [excluirAberto, setExcluirAberto] = useState(false);
  const [chamadoExcluir, setChamadoExcluir] = useState(null);

  // 🔹 Estado para editar
  const [editarAberto, setEditarAberto] = useState(false);
  const [chamadoEditar, setChamadoEditar] = useState(null);

  async function fetchChamados() {
    try {
      const resp = await fetch(`${API_URL}/chamados/listar.php`, {
        method: "GET",
        credentials: "include",
      });
      const data = await resp.json();
      setChamados(data || []);
    } catch (error) {
      console.error("Erro ao buscar chamados:", error);
      setChamados([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchChamados();
  }, []);

  // 🔹 Contagem de status
  const statusCounts = {
    todos: chamados.length,
    aberto: chamados.filter((c) => c.status === "Aberto").length,
    pendente: chamados.filter((c) => c.status === "Pendente").length,
    atendendo: chamados.filter((c) => c.status === "Atendendo").length,
    finalizado: chamados.filter((c) => c.status === "Finalizado").length,
  };

  useEffect(() => {
    if (onStatusCountsChange) {
      onStatusCountsChange(statusCounts);
    }
  }, [chamados]);

  // 🔹 Filtragem corrigida
  const chamadosFiltrados = chamados.filter((c) => {
    const filtroOk =
      (!filtro.data || (c.data_abertura || "").includes(filtro.data)) &&
      (!filtro.hora || (c.hora_abertura || "").includes(filtro.hora)) &&
      (!filtro.empresa ||
        (c.empresa || "").toLowerCase().includes(filtro.empresa.toLowerCase())) &&
      (!filtro.colaborador ||
        (c.colaborador || "")
          .toLowerCase()
          .includes(filtro.colaborador.toLowerCase())) &&
      (!filtro.tipo_servico ||
        (c.tipo_servico || "")
          .toLowerCase()
          .includes(filtro.tipo_servico.toLowerCase())) &&
      (!filtro.tecnico_responsavel ||
        (c.tecnico_responsavel || "")
          .toLowerCase()
          .includes(filtro.tecnico_responsavel.toLowerCase())) && // ✅ corrigido
      (!filtro.status || c.status === filtro.status);

    const filtroStatusOk = !filtroStatus || c.status === filtroStatus;
    return filtroOk && filtroStatusOk;
  });

  // 🔹 Ordenação quando "Todos"
  let chamadosOrdenados = [...chamadosFiltrados];
  if (!filtroStatus) {
    const ordem = { Pendente: 1, Aberto: 2, Atendendo: 3, Finalizado: 4 };
    chamadosOrdenados.sort(
      (a, b) => (ordem[a.status] || 99) - (ordem[b.status] || 99)
    );
  }

  // 🔹 Paginação
  const totalPaginas =
    itensPorPagina === Infinity
      ? 1
      : Math.max(1, Math.ceil(chamadosOrdenados.length / itensPorPagina));

  const inicio =
    itensPorPagina === Infinity ? 0 : (paginaAtual - 1) * itensPorPagina;
  const fim =
    itensPorPagina === Infinity
      ? chamadosOrdenados.length
      : inicio + itensPorPagina;
  const chamadosPaginados = chamadosOrdenados.slice(inicio, fim);

  // 🔹 Função excluir (com toast)
  async function handleExcluirConfirmado() {
    if (!chamadoExcluir) return;

    toast.promise(
      (async () => {
        const resp = await fetch(`${API_URL}/chamados/excluir.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: chamadoExcluir.id }),
        });

        const data = await resp.json();
        if (!data.sucesso) {
          throw new Error(data.erro || "Erro ao excluir chamado");
        }

        setChamados((prev) =>
          prev.filter((ch) => ch.id !== chamadoExcluir.id)
        );
        return true;
      })(),
      {
        loading: "🗑 Excluindo chamado...",
        success: "✅ Chamado excluído com sucesso!",
        error: "❌ Erro ao excluir chamado!",
      }
    );

    setExcluirAberto(false);
    setChamadoExcluir(null);
  }

  return (
    <div className="w-full relative">
      {/* 🔹 Tabela normal */}
      <div className="overflow-x-auto rounded-md border border-slate-400 shadow-sm">
        <table className="min-w-full border border-slate-400 table-fixed">
          <TabelaHeader filtro={filtro} setFiltro={setFiltro} />

          {/* 🔥 Animação na troca de página */}
          <AnimatePresence mode="wait">
            <motion.tbody
              key={paginaAtual}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-slate-500">
                    Carregando...
                  </td>
                </tr>
              ) : chamadosPaginados.length > 0 ? (
                chamadosPaginados.map((ch) => (
                  <TabelaRow
                    key={ch.id}
                    chamado={ch}
                    className="odd:bg-white even:bg-slate-50 hover:bg-slate-100 transition-colors"
                    onDetalhe={() => setChamadoSelecionado(ch)}
                    onEditar={() => {
                      setChamadoEditar(ch);
                      setEditarAberto(true);
                    }}
                    onExcluir={() => {
                      setChamadoExcluir(ch);
                      setExcluirAberto(true);
                    }}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-slate-500">
                    Nenhum chamado encontrado
                  </td>
                </tr>
              )}
            </motion.tbody>
          </AnimatePresence>
        </table>

        {!loading && chamadosFiltrados.length > 0 && (
          <Paginacao
            paginaAtual={paginaAtual}
            setPaginaAtual={setPaginaAtual}
            totalPaginas={totalPaginas}
            setItensPorPagina={setItensPorPagina}
            itensPorPagina={itensPorPagina}
          />
        )}
      </div>

      {/* 🔹 Modal Detalhe */}
      <Detalhe
        chamado={chamadoSelecionado}
        onClose={() => setChamadoSelecionado(null)}
      />

      {/* 🔹 Modal Excluir */}
      <ConfirmarExclusaoModal
        aberto={excluirAberto}
        onFechar={() => setExcluirAberto(false)}
        onConfirmar={handleExcluirConfirmado}
        nome={chamadoExcluir?.empresa || ""}
      />

      {/* 🔹 Modal Editar */}
      {editarAberto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-3/4 h-5/6 bg-white rounded-lg shadow-lg overflow-hidden">
            <FormularioEditarChamado
              chamado={chamadoEditar}
              onVoltar={() => setEditarAberto(false)}
              onSalvo={() => {
                fetchChamados(); // atualiza lista
                setEditarAberto(false);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
